module.exports = __webpack_public_path__ + "static/media/carrot.3dc5a284.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalNav/ProfileDropdown/assets/carrot.svg
// module id = 1932
// module chunks = 0